export enum COMMUNICATION_LIBRARY_ASSET_KEYS {
  LEAF_ICON = 'LEAF_ICON',
  BACK_GRAY_ICON = 'BACK_GRAY_ICON',
  DOWN_ICON = 'DOWN_ICON',
  UP_ICON = 'UP_ICON',
  SUCCESS_ICON = 'SUCCESS_ICON',
  FAILURE_ICON = 'FAILURE_ICON',
}

export type TermsConditionType = {
  openTermCondition: boolean;
  handleChangeTerms?: () => void;
  handleAcceptFun?: () => void;
  handleDeclineFun?: () => void;
};

export enum HIGHMARK_APP_TYPE {
  AMH = 'hm-allmyhealth',
  IEL = 'highmark-iel',
  BENEFICITY = 'highmark-beneficity',
}

export type CommunicationLibraryAssets = Record<
  COMMUNICATION_LIBRARY_ASSET_KEYS,
  unknown
>;
